import { useEffect, useMemo, useState } from "react";
import DataTable from "../../../Components/DataTable/DataTable";
import { dataFetchError } from "../../../Util/Messages";
import api from "../../../api/api";
import { Input, message, Select, Tag } from "antd";
import TextEditor from "../../../Components/TextEditor/TextEditor";

const AutoNoteManager = () => {
  const [data, setData] = useState([]);
  const [typeTags, setTypeTags] = useState([]);
  const columns = useMemo(
    () => [
      {
        title: "نام",
        dataIndex: "title",
        searchable: true,
        width: "15%",
        renderFormItem: (_, { isEditable, record }) => <Input />,
      },
      {
        title: "مقدار",
        dataIndex: "value",
        align: "center",
        width: "45%",
        render: (v, a) => {
          return <p dangerouslySetInnerHTML={{ __html: v }}></p>;
        },
        renderFormItem: (_, { isEditable, record }) => <TextEditor />,
      },
      {
        title: "تگ تایپ ها",
        dataIndex: "typeTags",
        filterMultiple: false,
        filterSearch: true,
        filters: typeTags.map((tag) => ({
          value: tag,
          text: tag,
        })),
        onFilter: (value, record) => {
          return record.typeTags.includes(value);
        },

        align: "center",
        render: (item) => {
          return item.map((e) => <Tag key={e}>{e}</Tag>);
        },
        renderFormItem: (_, { isEditable, record }) => {
          return (
            <Select
              mode="tags"
              allowClear
              style={{ width: "100%" }}
              placeholder="صفت‌ها را وارد کنید"
            >
              {typeTags?.map((tag) => (
                <Select.Option key={tag} value={tag}>
                  {tag}
                </Select.Option>
              ))}
            </Select>
          );
        },
      },
      {
        title: "اهمیت",
        dataIndex: "priority",
        align: "center",
        width: "7rem",
        searchable: true,
        render: (item) => {
          return item ?? 0;
        },
        renderFormItem: (_, { isEditable, record }) => {
          return (
            <Select allowClear style={{ width: "100%" }} placeholder="اهمیت">
              {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]?.map((tag) => (
                <Select.Option key={tag} value={tag}>
                  {tag}
                </Select.Option>
              ))}
            </Select>
          );
        },
      },
    ],
    [typeTags]
  );

  const loadFormAdjectives = () => {
    api
      .get(`/question-adjective/all`)
      .then((res) => {
        setTypeTags((prev) =>
          Array.from(new Set([...res.data.map((e) => e.adjective), ...prev]))
        );
      })
      .catch(() => message.error("خطا در دریافت صفت ها"));
  };

  const loadData = (...e) => {
    api
      .get("/auto-note")
      .then((res) => setData(res.data))
      .catch((err) => {
        console.log(err);
        dataFetchError();
      })
      .finally(() => {});
  };

  const updateRecord = async (id, data) => {
    return await api
      .put("/auto-note/" + id, {
        title: data.title,
        value: data.value,
        typeTags: data?.typeTags ?? [],
        priority: data?.priority ?? 0,
      })
      .then(() => message.success("با موفقیت آپدبت شد"))
      .catch(() => message.error("خطا در آپدیت"))
      .finally(() => {});
  };

  const saveRecord = async (data) => {
    return await api
      .post("/auto-note", {
        title: data.title,
        value: data.value,
        typeTags: data?.typeTags ?? [],
        priority: data?.priority ?? 0,
      })
      .then(() => message.success("با موفقیت ثبت شد"))
      .catch(() => message.error("خطا در ثبت"))
      .finally(() => {});
  };

  const onSaveHandler = async (row, rowData) => {
    let oldData = data.find((e) => e.id === row.id);
    return oldData
      ? updateRecord(oldData.id, rowData).then(() => {})
      : saveRecord(rowData).then(() => {});
  };

  useEffect(() => {
    loadData();
    loadFormAdjectives();
  }, []);

  return (
    <>
      <DataTable
        tableKey="auto-note-manager"
        dataSource={data}
        onSave={onSaveHandler}
        setDataSource={setData}
        columns={columns}
        reload={loadData}
        editable
        keepPageOnSave
        hideComment
        hideErrorReport
        path="/auto-note"
        permissionsPrefix="flags"
        header={{ title: "تگ نظر کارشناس" }}
      />
    </>
  );
};

export default AutoNoteManager;
